import { jsx as _jsx } from "react/jsx-runtime";
import Grid from '@mui/material/Grid';
export default function GridContainer({ children, spacing = 2 }) {
    return (_jsx(Grid, { container: true, spacing: spacing, children: children }));
}
